<apm-page-header [breadcrumbs]="breadcrumbs()" title="{{ 451845 | apmTranslate }}" backLink="../"></apm-page-header>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
